import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
import { whatsappLink } from '../lib/whatsapp';
import { useLanguage } from '../lib/i18n';
export function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);
  const {
    t,
    lang
  } = useLanguage();
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-128" data-mp="3etamte73zx9g">
      {visible && <motion.a href={whatsappLink('floating', lang)} target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp" initial={{
      opacity: 0,
      scale: 0.8,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.8,
      y: 20
    }} transition={{
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} className="fixed bottom-6 right-5 sm:bottom-8 sm:right-8 z-50 flex items-center justify-center gap-3 bg-terracotta hover:bg-terracottaDark text-ivory w-14 h-14 sm:w-auto sm:h-auto sm:pl-5 sm:pr-6 sm:py-4 rounded-full shadow-xl transition-colors duration-300" data-id="element-129" data-mp="3eu3lrszttih1">
          <MessageCircleIcon size={24} strokeWidth={1.5} className="sm:w-[22px] sm:h-[22px]" data-id="element-130" data-mp="1z9v5uiwnwaj" />
          <span className="hidden sm:inline text-sm tracking-wide font-medium" data-id="element-131" data-mp="718wyzyzyl5d">
            {t('floating.btn')}
          </span>
          <span className="absolute top-0 right-0 sm:-top-1 sm:-right-1 w-3.5 h-3.5 sm:w-3 sm:h-3 bg-olive rounded-full animate-pulse border-2 border-ivory sm:border-none" data-id="element-132" data-mp="2rq6d3tat3t3k" />
        </motion.a>}
    </AnimatePresence>;
}